module.exports = __webpack_public_path__ + "img/drbronner_2025_camper_quadrat.c1dc4703.webp";